import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { CtlGenKisiGelirAramaComponent } from './ctl-gen-kisi-gelir-arama/ctl-gen-kisi-gelir-arama.component';
import { KisiGelirService } from './ctl-gen-kisi-gelir.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
@Component({
  selector: 'dk-ctl-gen-kisi-gelir',
  templateUrl: './ctl-gen-kisi-gelir.component.html',
  styleUrls: ['./ctl-gen-kisi-gelir.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenKisiGelirAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
  ],
  providers: [KisiGelirService],
})
export class CtlGenKisiGelirComponent implements OnInit {
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "GenKisiGelir";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: any;
  @Input() labelWidth!: any;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: KisiGelirService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
      this.service.setParams(this.isReadOnly,this.isBindCheck)
  }
    ngOnChanges(changes: SimpleChanges) {
      if (changes['isReadOnly'] || changes['isBindCheck']) {
          this.service.setParams(this.isReadOnly,this.isBindCheck)
        }
    }

  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }
  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = '';
        if (result[0].Ad) this.title = this.title + result[0].Ad + ' ';
        if (result[0].Soyad) this.title = this.title + result[0].Soyad + ' ';
        if (result[0].Unvani) this.title = this.title + result[0].Unvani;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }
  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
